<template>
  <div class="content-container ">
    <slot/>
  </div>
</template>

<script>

export default {
  name: "orderTabContent",
};
</script>

<style scoped>
.content-container {
  max-height: var(--order-content-height);
  min-height: 300px;
  overflow-y: auto;
  padding: 5px;
  border-radius: 4px;
}

</style>
